module.exports = __webpack_public_path__ + "img/frame (230).e5981082.jpg";